var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TwitterLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.7071 9.7075L26.9696 13.445C26.2146 22.1975 18.8333 29 9.99957 29C8.18457 29 6.68832 28.7125 5.55207 28.145C4.63582 27.6863 4.26082 27.195 4.16707 27.055C4.08348 26.9296 4.0293 26.787 4.00857 26.6378C3.98785 26.4885 4.00112 26.3365 4.0474 26.1931C4.09368 26.0497 4.17176 25.9186 4.27582 25.8096C4.37988 25.7007 4.50722 25.6166 4.64832 25.5638C4.68082 25.5513 7.67832 24.4 9.58207 22.2088C8.5263 21.3407 7.60467 20.3214 6.84707 19.1838C5.29707 16.8825 3.56207 12.885 4.09707 6.91125C4.11403 6.72143 4.18488 6.54041 4.30126 6.38951C4.41765 6.2386 4.57474 6.1241 4.75402 6.05948C4.9333 5.99486 5.12732 5.98281 5.31322 6.02476C5.49912 6.06671 5.66916 6.1609 5.80332 6.29625C5.84707 6.34 9.96332 10.4338 14.9958 11.7613V11C14.9939 10.2017 15.1517 9.41117 15.46 8.67484C15.7683 7.93851 16.2208 7.2713 16.7908 6.7125C17.3444 6.15966 18.0032 5.7233 18.7282 5.42918C19.4532 5.13506 20.2298 4.98913 21.0121 5C22.0615 5.01035 23.0904 5.29207 23.9988 5.81776C24.9071 6.34345 25.664 7.09523 26.1958 8H29.9996C30.1975 7.99985 30.391 8.05841 30.5556 8.16828C30.7202 8.27815 30.8484 8.43439 30.9242 8.61721C30.9999 8.80003 31.0198 9.00122 30.9811 9.19531C30.9425 9.38939 30.8471 9.56765 30.7071 9.7075Z",
    fill: "#F99C5F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterB);
export default __webpack_public_path__ + "static/media/TwitterB.456c82862e9e3c1a528d3f8ca4de4de2.svg";
export { ForwardRef as ReactComponent };